import { React, classNames } from '@api'
import { SvgIcon } from '@material-ui/core';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import * as css from './AddIcon.css'

export class AddIcon extends React.Component<SvgIconProps> {
    static defaultProps = {
      viewBox: "0 0 24 24"
    }
  
    render() {
      const {className, ...props} = this.props;
  
      return (
        <SvgIcon className={classNames(css.root, className)} {...props}>
          <path
            d="M6,2 L18,2 C20.209139,2 22,3.790861 22,6 L22,18 C22,20.209139 20.209139,22 18,22 L6,22 C3.790861,22 2,20.209139 2,18 L2,6 C2,3.790861 3.790861,2 6,2 Z M6,4 C4.8954305,4 4,4.8954305 4,6 L4,18 C4,19.1045695 4.8954305,20 6,20 L18,20 C19.1045695,20 20,19.1045695 20,18 L20,6 C20,4.8954305 19.1045695,4 18,4 L6,4 Z M13,11 L17,11 L17,13 L13,13 L13,17 L11,17 L11,13 L7,13 L7,11 L11,11 L11,7 L13,7 L13,11 Z"
          />
        </SvgIcon>
      )
    }
  }


// WEBPACK FOOTER //
// ./src/shared/components/ui/widgets/AddIcon.tsx